export default {
      id: "arrawDown-usage",
      viewBox: "0 0 8 7",
      url: __webpack_public_path__ + "img/icons.cd84ca0f.svg#arrawDown",
      toString: function () {
        return this.url;
      }
    }